import Footer from "components/Primary/Footer";
import Header from "components/Primary/Header";
import VerticalNavigationTab from "components/Secondary/VerticalNavigationTab";
import OpenOrders from "components/WalletsPage/OpenOrders";
import {ReactComponent as OpenOrdersIcon} from "../../assets/icons/openOrdersIcon.svg";
import {ReactComponent as FeesIcon} from "../../assets/icons/feesIcon.svg";
import {ReactComponent as OverviewIcon} from "../../assets/icons/overviewIcon.svg";
import {ReactComponent as RewardsIcon} from "../../assets/icons/rewardsIcon.svg";
import {ReactComponent as TradingHistoryIcon} from "../../assets/icons/tradingHistoryIcon.svg";
import { useState } from "react";
import WalletsOverview from "components/WalletsPage/Overview";
import TradingHistory from "components/WalletsPage/TradingHistory";
import Fees from "components/WalletsPage/Fees";
import { useLocation } from "react-router-dom";
import useWindowDimensions from "helpers/screen";
import "./style.scss";

const WalletsPage = ({}) => {
  const [curPage, setCurPage] = useState("/wallet")
  const location = useLocation();
  const {width} = useWindowDimensions();

  return <div className="walletsPage">
    <Header/>
    <div className="walletsMain">
      {width > 900 &&
        <div className="sidebar">
          <VerticalNavigationTab members={[
            {url: "/wallet", title: "Overview", icon: <OverviewIcon/>},
            // {url: "/wallet/openorders", title: "Open Orders", icon: <OpenOrdersIcon/>},
            // {url: "/wallet/tradinghistory", title: "Trading History", icon: <TradingHistoryIcon/>},
            // {url: "/wallet/rewards", title: "Rewards", icon: <RewardsIcon/>},
            // {url: "/wallet/fees", title: "Fees", icon: <FeesIcon/>},
          ]}
          horizontal={false}/>
        </div>
      }
        {
          (() => {
            switch(location.pathname){
              case "/wallet":
                return <WalletsOverview/>
              case "/wallet/openorders":
                return <OpenOrders/>
              case "/wallet/tradinghistory":
                return <TradingHistory/>
              case "/wallet/fees":
                return <Fees/>
            }
          })()
        }

    </div>
     {width <= 900 ?
      <Footer childElem={
        <VerticalNavigationTab members={[
          {url: "/wallet", title: "Overview", icon: <OverviewIcon/>},
          // {url: "/wallet/openorders", title: "Open Orders", icon: <OpenOrdersIcon/>},
          // {url: "/wallet/tradinghistory", title: "History", icon: <TradingHistoryIcon/>},
          // {url: "/wallet/rewards", title: "Rewards", icon: <RewardsIcon/>},
          // {url: "/wallet/fees", title: "Fees", icon: <FeesIcon/>},
        ]}
        horizontal={true}/>
      }/>:
      <Footer/>
     }
  </div>
}

export default WalletsPage;